import React from 'react'
import FormEdit from '../../common/CommonComponents/FormEdit'

export default function UpdateTags({ show,
    title,
    width,
    height,
    setShow,
    data,
    saveDisabled,
    saveFunction,
    updateData,
    setConfirm
}) {
    const itemData = data;
    //copy test
    const visible = show || false;
    const titleText = title || "Welcome";
    const dspWidth = width || "600px";
    const dspHeight = height || "80%";
    const setVisble = setShow || null;

    const newData = {
        'caasid': itemData.caas_id,
        'customerEnterpriseId': itemData.caas_customerEID,
        'secondaryPOC': itemData.caas_secondaryPOC,
        'environment': itemData.caas_environment,
        'initiative': itemData.caas_intiative,
        'wbsecode': itemData.caas_wbsecode,
        'serviceEndDate': itemData.caas_sed,
        'projectName': itemData.caas_projectName,
        'contractId': itemData.caas_contractID,
        'notes': itemData.caas_notes,
        'orderid': itemData.caas_orderItemUid,
        'ceid': itemData.caas_customerEID,
        'appcore': itemData.caas_appcore,
        'dcr': itemData.caas_dcr
    };

    const onChange = (event) => {
        const { name, value } = event.target;
        newData[name] = value;
    }

    const updateTags = () => {
        setConfirm({
            appName: 'gwConfirm',
            config: {
                stateFunction: setConfirm,
                text: (<>Are you sure want to Update Tags</>),
                onloop: true,
                width: 360,
                height: 190,
                bntYes: () => {
                    saveFunction(newData);
                }
            },
        });

    }

    return (
        <FormEdit show={visible} title={titleText} width={dspWidth} height={dspHeight} setShow={setVisble} saveDisabled={saveDisabled} saveFunction={updateTags}>
            <div style={{ fontSize: '.9rem' }}>
                <form id='editTags' className='formDataEdit'>
                    <div className='formInputs'>
                        <label>Customer Enterprise ID:</label>
                        <input type="text" name="customerEnterpriseId" defaultValue={newData.customerEnterpriseId} onChange={onChange} />
                    </div>
                    <div className='formInputs'>
                        <label>Secondary POC:</label>
                        <input type="text" name="secondaryPOC" defaultValue={newData.secondaryPOC} onChange={onChange} />
                    </div>
                    <div className='formInputs'>
                        <label>Environment:</label>
                        <select type="text" name="environment" defaultValue={newData.environment} onChange={onChange}>
                            <option value="production">Production</option>
                            <option value="dev">Dev</option>
                            <option value="uat">Uat</option>
                            <option value="sales">Sales</option>
                            <option value="test">Test</option>
                        </select>
                    </div>
                    <div className='formInputs'>
                        <label>Initiative:</label>
                        <select type="text" name="initiative" defaultValue={newData.initiative} onChange={onChange}>
                            <option value="Agile Capability">Agile Capability</option>
                            <option value="Change Enablement">Change Enablement</option>
                            <option value="FORM, Methods & Estimators">FORM, Methods & Estimators</option>
                            <option value="Language Translation Services">Language Translation Services</option>
                            <option value="Living Systems Advisory">Living Systems Advisory</option>
                            <option value="1AAA">1AAA</option>
                            <option value="DevOps Capability">DevOps Capability</option>
                            <option value="ICS">ICS</option>
                            <option value="IEMP">IEMP</option>
                            <option value="myDiagnostic">myDiagnostic</option>
                            <option value="myIndustry">myIndustry</option>
                            <option value="myMDI">myMDI</option>
                            <option value="myNav">myNav</option>
                            <option value="mySP">mySP</option>
                            <option value="myWizard Apps">myWizard - Other Apps</option>
                            <option value="myWizard AI Apps">myWizard AI Apps</option>
                            <option value="myWizard_AiOps">Mywizard AiOps</option>
                            <option value="myWizard Governance">Mywizard Governance</option>
                            <option value="myWizard Platform Mgt">Mywizard Platform Mgt</option>
                            <option value="myWizard SaaS">myWizard SaaS</option>
                            <option value="myWizard SI">myWizard SI</option>
                            <option value="Technical architecture">Technical architecture</option>
                            <option value="Transformation Office">Transformation Office</option>
                            <option value="UX">UX</option>
                            <option value="Automation Deployment">Automation Deployment</option>
                            <option value="Sales & Solutions">Automation Sales & Solution</option>
                            <option value="PMO">PMO</option>
                        </select>
                    </div>
                    <div className='formInputs'>
                        <label>WBSE Code:</label>
                        <input type="text" name="wbseCode" defaultValue={newData.wbsecode} onChange={onChange} />
                    </div>
                    <div className='formInputs'>
                        <label>Service End Date:</label>
                        <input type="date" name="serviceEndDate" defaultValue={newData.serviceEndDate} onChange={onChange} />
                    </div>
                    <div className='formInputs'>
                        <label>Project Name:</label>
                        <input type="text" name="projectName" defaultValue={newData.projectName} onChange={onChange} />
                    </div>
                    <div className='formInputs'>
                        <label>SAP Contract ID:</label>
                        <input type="text" name="projectName" defaultValue={newData.contractId} onChange={onChange} />
                    </div>
                    <div className='formInputs' style={{ height: '80px' }}>
                        <label>Notes:</label>
                        <textarea type="text" name="notes" onChange={onChange} defaultValue={newData.notes}></textarea>
                    </div>
                </form>
            </div>
        </FormEdit>
    )
}
